import { MutableRefObject, useEffect, useRef } from 'react';

import ReplaceOmbedWithVideoProps from '@/components/shared/helpers/hooks/use-replace-ombed-with-video/type';

function useReplaceOembedWithVideo({
  htmlContent,
  dependency,
}: ReplaceOmbedWithVideoProps): MutableRefObject<HTMLDivElement | null> {
  const contentRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (contentRef.current) {
      const figures = contentRef.current.querySelectorAll('figure.media oembed');
      figures.forEach((oembed) => {
        const videoUrl = oembed.getAttribute('url');
        if (videoUrl) {
          const videoElement = document.createElement('video');
          videoElement.src = videoUrl;
          videoElement.controls = true;
          oembed.parentElement?.replaceChild(videoElement, oembed); // Replace <oembed> with <video>
        }
      });
    }
  }, [htmlContent, dependency]);

  return contentRef;
}

export default useReplaceOembedWithVideo;
